import { Icon, Paper, Typography } from "@material-ui/core"
import { DocumentContext } from "context"
import {
  COMPLETED_PATH,
  ENTERED_PATH,
  ON_HOLD_PATH,
  PENDING_PATH,
  REJECTED_PATH,
} from "lib"
import React from "react"
import CountUp from "react-countup"
import { useHistory } from "react-router-dom"

interface Props {
  countPath: string
  isOnHold?: boolean
}

const CountDocuments = React.memo((props: Props) => {
  const { countPath, isOnHold } = props
  const { count } = React.useContext(DocumentContext)
  const { completed, rejected, onHold, pending, total, entered } = count
  const [recount, setRecount] = React.useState<number>(0)
  const history = useHistory()

  React.useEffect(() => {
    setRecount(Math.random())
  }, [])

  return (
    <div className="flex items-center w-full pb-4 justify-between">
      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: "#ffd54f",
          flex: 1,
        }}
        elevation={0}
        onClick={() => history.push(`${countPath}${ENTERED_PATH}`)}
      >
        <div className="glass-md flex items-center justify-center p-2">
          <Icon className="opacity-50">arrow_upward</Icon>
        </div>
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={entered}>
            {({ countUpRef }) => (
              <div>
                <Typography
                  color="textSecondary"
                  variant="h5"
                  style={{ fontWeight: 900 }}
                >
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {"Ingresados"}
          </Typography>
        </div>
      </Paper>
      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: "#fbc02d",
          flex: 1,
        }}
        elevation={0}
        onClick={() => history.push(`${countPath}${PENDING_PATH}`)}
      >
        <div className="glass-md flex items-center justify-center p-2">
          <Icon className="opacity-50">timelapse</Icon>
        </div>
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={pending}>
            {({ countUpRef }) => (
              <div>
                <Typography
                  color="textSecondary"
                  variant="h5"
                  style={{ fontWeight: 900 }}
                >
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {"Pendientes"}
          </Typography>
        </div>
      </Paper>

      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: "#f9a825",
          flex: 1,
        }}
        elevation={0}
        onClick={() => history.push(`${countPath}${ON_HOLD_PATH}`)}
      >
        <div className="glass-md flex items-center justify-center p-2">
          <Icon className="opacity-50">close</Icon>
        </div>
        <div className="ml-4">  
          <CountUp
            start={recount}
            duration={1}
            end={isOnHold ? onHold : rejected}
          >
            {({ countUpRef }) => (
              <div>
                <Typography
                  color="textSecondary"
                  variant="h5"
                  style={{ fontWeight: 900 }}
                >
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {isOnHold ? "En Espera" : "Rechazados"}
          </Typography>
        </div>
      </Paper>

      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: "#ffa000",
          flex: 1,
          maxWidth: "50%",
        }}
        elevation={0}
        onClick={(e) => {
          e.stopPropagation()
          history.push(`${countPath}${COMPLETED_PATH}`)
        }}
      >
        <div className="glass-md flex items-center justify-center p-2">
          <Icon className="opacity-50">flag</Icon>
        </div>
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={completed}>
            {({ countUpRef }) => (
              <div>
                <Typography
                  color="textSecondary"
                  variant="h5"
                  style={{ fontWeight: 900 }}
                >
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {"Finalizados"}
          </Typography>
        </div>
      </Paper>
      <Paper
        className="px-4 py-3 flex items-center justify-start relative overflow-hidden"
        style={{
          backgroundColor: "#ff8f00",
        }}
        elevation={0}
      >
        <div className="mx-4">
          <CountUp start={recount} duration={1} end={total}>
            {({ countUpRef }) => (
              <div>
                <Typography
                  color="textSecondary"
                  variant="h5"
                  style={{ fontWeight: 900 }}
                  align="center"
                >
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="body1" className="opacity-75" align="center">
            {"Total"}
          </Typography>
        </div>
      </Paper>
    </div>
  )
})

export default CountDocuments
